var exports = {
  "az": "Box__RcSzit",
  "DZ": "Heading__vFUDtP",
  "$K": "HeadingUnderline__VNW9rO",
  "wy": "Box_1__R6c2lN",
  "EY": "Text__LRs_Fg",
  "pv": "Box_2__xHMhZ6",
  "w9": "Box_3__8vxQsp",
  "UE": "Text_1__pFM8cW",
  "pQ": "Box_4__v8FWUR",
  "Nl": "Text_2__UOzhuj",
  "UZ": "Text_3__r3HVEG",
  "do": "Heading_1__uzjMjk",
  "ws": "Box_5__o1I_Q6",
  "D6": "Box_6__y0CYZs",
  "N8": "Text_4__B0Uz-u",
  "KI": "Box_7__MxGx6l",
  "pm": "Box_8__w9VM1B",
  "Hh": "ActionMenu_Button__-rw6L-",
  "RN": "ActionList_Item__n6Cmdw",
  "Tr": "Button_1__TuRQsr",
  "Dv": "IssueFieldsError___eUgz0",
};

module.exports = exports;
